import InfoBlock from "../../../../src/components/custom-blocks/info-block";
import EventTargetInfo from "../../../../src/posts/2021-02-16-click-event-target/event-target-info.mdx";
import * as React from 'react';
export default {
  InfoBlock,
  EventTargetInfo,
  React
};